import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgAlipay({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 19a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h14a2 2 0 012 2v10.213c-1.86-.628-3.817-1.36-5.69-1.988l.198-.386a26.128 26.128 0 001.268-3.04h-3.401v-1.18h4.192v-.72h-4.192V6h-1.952v1.9H7.231v.718h4.192v1.18H7.897v.632h6.813l-.133.37a14.668 14.668 0 01-.878 1.905c-1.827-.556-3.514-.943-4.867-.943-3.246 0-3.966 1.606-3.813 3.075.124 1.173 1.01 2.884 3.715 2.884 2.47 0 4.466-1.395 5.693-3.056C16.768 15.727 19.241 17.035 21 18v1zM8.659 12.795c.96 0 2.483.482 4.192 1.186-.966 1.25-2.514 2.748-4.51 2.748-2.208 0-2.614-1.184-2.675-1.947l-.005-.08c-.038-.663.417-1.907 2.998-1.907z"
        fill="#000"
      />
    </svg>
  )
}

export default SvgAlipay
